<template src="./Questions.html" />

<script>
// components
import Quote from "@/components/Quote/Quote";
import Table1 from '../Tables/Table1';
import Table2 from '../Tables/Table2';
import Table3 from '../Tables/Table3';
import Table4 from '../Tables/Table4';
import PanzoomImagesContainer from '../PanzoomImagesContainer/PanzoomImagesContainer';
import GraphicAnimation from '../common/GraphicAnimation/GraphicAnimation'

// vuex
import { mapState } from 'vuex';
import IsOnViewport from '../../mixins/IsOnViewport';
import UserAgent from '../../store/modules/UserAgent';
import Analytics from '../../mixins/Analytics';

export default {
  name: "Questions",
  components: {
    Quote,
    Table1,
    Table2,
    Table3,
    Table4,
    PanzoomImagesContainer,
    GraphicAnimation
  },
  computed: {
    ...mapState(['UserAgent', 'animationsData', 'questionsList']),
  },
  data() {
    return {
    }
  },
  methods: {

  },
  mixins: [IsOnViewport, Analytics]
}
</script>

<style scoped src="./Questions.scss" lang="scss" />

